import posthog from "posthog-js";

type LogLevel = "info" | "warn" | "error";

class PostHogLogger {
  private static instance: PostHogLogger;

  static getInstance(): PostHogLogger {
    if (!PostHogLogger.instance) PostHogLogger.instance = new PostHogLogger();
    return PostHogLogger.instance;
  }

  private capture(level: LogLevel, message: string, context?: unknown) {
    if (typeof document === "undefined") return;

    const properties: Record<string, unknown> = {
      level,
      message,
      ...(context !== undefined ? { payload: context } : {})
    };

    posthog.capture(`log_${level}`, properties);
  }

  info(message: string, context?: unknown) {
    this.capture("info", message, context);
  }

  warn(message: string, context?: unknown) {
    this.capture("warn", message, context);
  }

  error(message: string, context?: unknown) {
    this.capture("error", message, context);
  }
}

export const logger = PostHogLogger.getInstance();
